"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _exchangeUiComponents = require("@mulesoft/exchange-ui-components");
var _Tooltip = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Tooltip"));
var _classnames = _interopRequireDefault(require("classnames"));
var _hooks = require("./hooks");
var _Loading = _interopRequireDefault(require("./Loading"));
var styles = {
  "loading": "Metrics__loading__26wnH",
  "metadata-item": "Metrics__metadata-item__h4SBP",
  "metadataItem": "Metrics__metadata-item__h4SBP",
  "engagement-metric": "Metrics__engagement-metric__1OsrL",
  "engagementMetric": "Metrics__engagement-metric__1OsrL",
  "metadata-item-wrapper": "Metrics__metadata-item-wrapper__1NpuO",
  "metadataItemWrapper": "Metrics__metadata-item-wrapper__1NpuO"
}; 
require('./Metrics.css');
var Metrics = function Metrics() {
  var _useVAPMetrics = (0, _hooks.useVAPMetrics)(),
    engagement = _useVAPMetrics.engagement;
  var isLoading = engagement === null;
  return /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    testId: "engagement-score-tooltip",
    content: "The engagement score reflects the usage of the asset in context of usage of all assets in the customer root organization and business groups",
    position: "top"
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "engagement-container",
    className: styles.metadataItemWrapper
  }, "Engagement score", /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(styles.metadataItem, styles.engagementMetric)
  }, isLoading ? /*#__PURE__*/_react.default.createElement(_Loading.default, {
    testId: "metrics-engagement-loading"
  }) : null, !isLoading ? /*#__PURE__*/_react.default.createElement(_exchangeUiComponents.ProgressBar, {
    testId: "metrics-engagement-score",
    label: "Engagement score",
    isPercentage: true,
    value: engagement,
    denominatorValue: 1,
    maxValue: 1,
    color: "#a39a57"
  }) : null)));
};
var _default = exports.default = Metrics;
//# sourceMappingURL=Metrics.js.map